// Module
var code = " <flow-report-all-data-items-v1 flow-model-id=\"ctrl.flowModelId\" start-date-override=\"ctrl.startDate\" end-date-override=\"ctrl.endDate\"> </flow-report-all-data-items-v1> ";
// Exports
export default code;